module.exports = __webpack_public_path__ + "static/media/down-arrow.ae804293.svg";